const SIGNUP_RESPONSE = {
  OperationResult: 'OperationResult',
  WrongEmail: 'WrongEmail',
  WrongPhonenumber: 'WrongPhonenumber',
  WrongPassword: 'WrongPassword',
  Unauthorized: 'Unauthorized',
};

export default SIGNUP_RESPONSE;
